// Nén + resize ảnh phía client trước khi upload (tương đương app: resize 800px, nén 0.6).
// Trả về File JPEG đã nén. Nếu lỗi (file không phải ảnh...) → trả lại file gốc.
export async function compressImage(file, { maxWidth = 800, quality = 0.6 } = {}) {
    if (!file || !file.type?.startsWith('image/')) return file;
    try {
        const dataUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

        const img = await new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = reject;
            image.src = dataUrl;
        });

        const scale = img.width > maxWidth ? maxWidth / img.width : 1;
        const targetW = Math.round(img.width * scale);
        const targetH = Math.round(img.height * scale);

        const canvas = document.createElement('canvas');
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, targetW, targetH);

        const blob = await new Promise((resolve) =>
            canvas.toBlob(resolve, 'image/jpeg', quality),
        );
        if (!blob) return file;

        const name = (file.name || 'image').replace(/\.[^.]+$/, '') + '.jpg';
        return new File([blob], name, { type: 'image/jpeg' });
    } catch {
        return file;
    }
}
